import React, { useDeferredValue, useState } from 'react';

import { createRouterContext } from './context';
import type { IProps } from './models';

/** Компонент, управляющий роутами */
export const Router = <S,>({ children, defaultRoute, name }: IProps<S>) => {
    const Context = createRouterContext<S>();
    const [route, setRoute] = useState<S>(defaultRoute);
    const deferredRoute = useDeferredValue<S>(route);

    const switchRoute = (nextRoute: S) => {
        setRoute(nextRoute);

        return deferredRoute;
    };

    return (
        <Context.Consumer>
            {parent => {
                return (
                    <Context.Provider
                        value={{
                            name,
                            route,
                            parent,
                            switchRoute,
                        }}
                    >
                        {children}
                    </Context.Provider>
                );
            }}
        </Context.Consumer>
    );
};
